import SubscriptionIssueDialog from './subscription-issue-dialog';
import { Button } from '@shadcn/ui/components/ui/button';

interface NoSeatsLeftInfoDialogProps {
    organizationName: string;
    activeUsersCount: number;
    adminEmail?: string;
    open?: boolean;
}

interface SubscriptionCancelledDialogProps {
    organizationName: string;
    activeUsersCount: number;
    isLoading?: boolean;
    handleReactivate?: () => void;
    open?: boolean;
}

interface NoSeatsLeftInfoProps {
    adminEmail?: string;
}

const NoSeatsLeftInfo = ({ adminEmail }: NoSeatsLeftInfoProps) => (
    <>
        <h2 className="text-2xl font-bold">Looks like there are no seats left</h2>
        <p className="text-base text-secondary-foreground">
            To join this team, reach out to your workspace admin{' '}
            <span className="underline text-blue-600">{adminEmail}</span> and ask to assign you a paid seat.
        </p>
    </>
);

const SubscriptionCancelledInfo = ({
    isLoading,
    handleReactivate,
}: {
    isLoading: boolean;
    handleReactivate: () => void;
}) => {
    return (
        <>
            <h2 className="text-2xl font-bold mb-2">Subscription has been cancelled</h2>
            <p className="text-muted-foreground mb-4">Reactivate account on free plan</p>
            <Button variant="default" className="w-full" disabled={isLoading} onClick={handleReactivate}>
                {isLoading ? (
                    <span className="flex items-center">
                        <svg
                            className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                        </svg>
                        Reactivating...
                    </span>
                ) : (
                    'Reactivate'
                )}
            </Button>
        </>
    );
};

export const NoSeatsLeftInfoDialog = ({
    organizationName,
    activeUsersCount,
    adminEmail,
    open = true,
}: NoSeatsLeftInfoDialogProps) => {
    return (
        <SubscriptionIssueDialog organizationName={organizationName} activeUsersCount={activeUsersCount} open={open}>
            <NoSeatsLeftInfo adminEmail={adminEmail} />
        </SubscriptionIssueDialog>
    );
};

export const SubscriptionCancelledInfoDialog = ({
    organizationName,
    activeUsersCount,
    isLoading,
    handleReactivate,
    open = true,
}: SubscriptionCancelledDialogProps) => {
    return (
        <SubscriptionIssueDialog
            organizationName={organizationName}
            activeUsersCount={activeUsersCount || 0}
            open={true}
        >
            <SubscriptionCancelledInfo isLoading={isLoading} handleReactivate={handleReactivate} />
        </SubscriptionIssueDialog>
    );
};
